// Messages for design-system/components/Modal (auto-merged by lib/i18n.ts).
export const en = {
  'modal.maximize': 'Expand to full screen',
  'modal.restore': 'Restore normal size',
  'modal.close': 'Close',
  'modal.close_dialog': 'Close dialog',
}

export const zhTW = {
  'modal.maximize': '展開為全螢幕',
  'modal.restore': '還原正常大小',
  'modal.close': '關閉',
  'modal.close_dialog': '關閉對話框',
}
